import { CoreValue } from "@shared/models";

// Relative paths, not the "@assets" alias: "@assets/*" isn't in jest's moduleNameMapper (only the
// webpack config is aliased, via config-overrides.js's react-app-rewire-alias) -- same reasoning as
// rewardArtwork.ts's own comment, the one other place in this repo that builds a code-to-artwork map.
// A static import per file (not a dynamic `require`) so webpack fingerprints every asset.
import stayStudentT1 from "../../../../assets/images/coreValueBadges/stay-student-t1.png";
import stayStudentT2 from "../../../../assets/images/coreValueBadges/stay-student-t2.png";
import stayStudentT3 from "../../../../assets/images/coreValueBadges/stay-student-t3.png";
import stayStudentT4 from "../../../../assets/images/coreValueBadges/stay-student-t4.png";
import stayStudentT5 from "../../../../assets/images/coreValueBadges/stay-student-t5.png";
import stayStudentT6 from "../../../../assets/images/coreValueBadges/stay-student-t6.png";
import stayStudentT7 from "../../../../assets/images/coreValueBadges/stay-student-t7.png";
import stayStudentT8 from "../../../../assets/images/coreValueBadges/stay-student-t8.png";
import helpOtherT1 from "../../../../assets/images/coreValueBadges/help-other-t1.png";
import helpOtherT2 from "../../../../assets/images/coreValueBadges/help-other-t2.png";
import helpOtherT3 from "../../../../assets/images/coreValueBadges/help-other-t3.png";
import helpOtherT4 from "../../../../assets/images/coreValueBadges/help-other-t4.png";
import helpOtherT5 from "../../../../assets/images/coreValueBadges/help-other-t5.png";
import helpOtherT6 from "../../../../assets/images/coreValueBadges/help-other-t6.png";
import helpOtherT7 from "../../../../assets/images/coreValueBadges/help-other-t7.png";
import helpOtherT8 from "../../../../assets/images/coreValueBadges/help-other-t8.png";
import accountabilityT1 from "../../../../assets/images/coreValueBadges/accountability-t1.png";
import accountabilityT2 from "../../../../assets/images/coreValueBadges/accountability-t2.png";
import accountabilityT3 from "../../../../assets/images/coreValueBadges/accountability-t3.png";
import accountabilityT4 from "../../../../assets/images/coreValueBadges/accountability-t4.png";
import accountabilityT5 from "../../../../assets/images/coreValueBadges/accountability-t5.png";
import accountabilityT6 from "../../../../assets/images/coreValueBadges/accountability-t6.png";
import accountabilityT7 from "../../../../assets/images/coreValueBadges/accountability-t7.png";
import accountabilityT8 from "../../../../assets/images/coreValueBadges/accountability-t8.png";
import raiseBarT1 from "../../../../assets/images/coreValueBadges/raise-bar-t1.png";
import raiseBarT2 from "../../../../assets/images/coreValueBadges/raise-bar-t2.png";
import raiseBarT3 from "../../../../assets/images/coreValueBadges/raise-bar-t3.png";
import raiseBarT4 from "../../../../assets/images/coreValueBadges/raise-bar-t4.png";
import raiseBarT5 from "../../../../assets/images/coreValueBadges/raise-bar-t5.png";
import raiseBarT6 from "../../../../assets/images/coreValueBadges/raise-bar-t6.png";
import raiseBarT7 from "../../../../assets/images/coreValueBadges/raise-bar-t7.png";
import raiseBarT8 from "../../../../assets/images/coreValueBadges/raise-bar-t8.png";
import keepPushingT1 from "../../../../assets/images/coreValueBadges/keep-pushing-t1.png";
import keepPushingT2 from "../../../../assets/images/coreValueBadges/keep-pushing-t2.png";
import keepPushingT3 from "../../../../assets/images/coreValueBadges/keep-pushing-t3.png";
import keepPushingT4 from "../../../../assets/images/coreValueBadges/keep-pushing-t4.png";
import keepPushingT5 from "../../../../assets/images/coreValueBadges/keep-pushing-t5.png";
import keepPushingT6 from "../../../../assets/images/coreValueBadges/keep-pushing-t6.png";
import keepPushingT7 from "../../../../assets/images/coreValueBadges/keep-pushing-t7.png";
import keepPushingT8 from "../../../../assets/images/coreValueBadges/keep-pushing-t8.png";

/**
 * Bundled per-value badge artwork (176x176 PNG, transparent — this art is never served, unlike every
 * other badge's `icon_url`), keyed by `"<slug>-t<tier>"`. `slug` is the core value's OWN icon slug —
 * the basename of its `icon_url` minus extension, e.g. `core-values/stay-student.svg` -> `stay-student`
 * — which is byte-identical to this map's filenames and this key's own left half, so
 * `resolveCoreValueBadgeArt` below does no case or separator conversion: the slug is used verbatim.
 */
const CORE_VALUE_BADGE_ART: Record<string, string> = {
  "stay-student-t1": stayStudentT1,
  "stay-student-t2": stayStudentT2,
  "stay-student-t3": stayStudentT3,
  "stay-student-t4": stayStudentT4,
  "stay-student-t5": stayStudentT5,
  "stay-student-t6": stayStudentT6,
  "stay-student-t7": stayStudentT7,
  "stay-student-t8": stayStudentT8,
  "help-other-t1": helpOtherT1,
  "help-other-t2": helpOtherT2,
  "help-other-t3": helpOtherT3,
  "help-other-t4": helpOtherT4,
  "help-other-t5": helpOtherT5,
  "help-other-t6": helpOtherT6,
  "help-other-t7": helpOtherT7,
  "help-other-t8": helpOtherT8,
  "accountability-t1": accountabilityT1,
  "accountability-t2": accountabilityT2,
  "accountability-t3": accountabilityT3,
  "accountability-t4": accountabilityT4,
  "accountability-t5": accountabilityT5,
  "accountability-t6": accountabilityT6,
  "accountability-t7": accountabilityT7,
  "accountability-t8": accountabilityT8,
  "raise-bar-t1": raiseBarT1,
  "raise-bar-t2": raiseBarT2,
  "raise-bar-t3": raiseBarT3,
  "raise-bar-t4": raiseBarT4,
  "raise-bar-t5": raiseBarT5,
  "raise-bar-t6": raiseBarT6,
  "raise-bar-t7": raiseBarT7,
  "raise-bar-t8": raiseBarT8,
  "keep-pushing-t1": keepPushingT1,
  "keep-pushing-t2": keepPushingT2,
  "keep-pushing-t3": keepPushingT3,
  "keep-pushing-t4": keepPushingT4,
  "keep-pushing-t5": keepPushingT5,
  "keep-pushing-t6": keepPushingT6,
  "keep-pushing-t7": keepPushingT7,
  "keep-pushing-t8": keepPushingT8,
};

// Mirrors the api's own `badge_definitions.code` shape for a per-value badge
// (api/app/shared/constants/badge.ts:31): `value:<coreValueId>:t<tier>`. Tiers run 1-8 -- one per
// bundled asset per core value (40 files: 5 values x 8 tiers) -- so the pattern itself only accepts a
// single digit 1-8; anything else is not a real badge and simply doesn't match.
const VALUE_CODE_PATTERN = /^value:(\d+):t([1-8])$/;

// Older icon slugs a core value may still carry, mapped to the slug its art is filed under. Raise the
// Bar was seeded as "Remain humble confident" with `core-values/humble-confident.svg`
// (api `20230517100020_Insert-CoreValue.js`). `20241030131859_Update-CoreValues.js` meant to repoint it
// to `raise-bar.svg` but searched for the misspelt "Remain humbly confident", and
// `20260804090000_Fix-CoreValueTitles.js` records it matching zero rows on a fresh install; that fix
// renames the title only and never touches `icon_url`. So an environment may still hold
// `humble-confident.svg` for this value (the local QA copy has `raise-bar.svg`; production is
// unverified) -- without this alias all eight Raise the Bar badges would silently render without art.
const SLUG_ALIASES: Record<string, string> = {
  "humble-confident": "raise-bar",
};

/**
 * The basename of a URL's path, minus its extension — e.g. `".../core-values/stay-student.svg"` ->
 * `"stay-student"`. Returns `null` (never throws) for anything that doesn't have both a path segment
 * and a `.<extension>` suffix, which is the only shape `resolveCoreValueBadgeArt` below treats as
 * "parseable".
 */
const basenameWithoutExtension = (url: string): string | null => {
  const lastSegment = url.split("/").pop();
  if (!lastSegment) {
    return null;
  }

  const match = lastSegment.match(/^(.+)\.[^./]+$/);
  return match ? match[1] : null;
};

/**
 * Resolves a badge's `code` to its bundled per-value artwork, or `null` when there is none — the
 * caller (`BadgeCard`, `BadgeOverlayDetailsContainer`) then renders exactly as it does today for a
 * badge with no icon: no background image, never a blank/broken tile.
 *
 * The api embeds the core value's DATABASE id in the code, and that id differs by environment, so a
 * hardcoded id-to-slug table would be wrong somewhere. The one stable link is the core value's own
 * `icon_url`, whose basename already matches this module's asset filenames exactly (see
 * `CORE_VALUE_BADGE_ART`'s own comment) — so the lookup is: parse the id and tier off `code`, find that
 * core value in the already-fetched catalog, and use its `icon_url`'s basename as-is (after
 * `SLUG_ALIASES`, for a value that may still carry an older icon file name).
 *
 * Never throws. Returns `null` for every one of: `code` isn't a `value:` code at all (every other
 * badge category — flame/tenure/achievement/seasonal); the id doesn't match any core value in
 * `coreValues` (an unknown/not-yet-loaded id); the tier is outside 1-8; the matched core value's
 * `icon_url` is missing/empty/unparseable (defensive against `CoreValue.icon_url`'s declared type
 * being a non-null `string` when the real data is not always that certain); or the resolved slug+tier
 * simply has no entry in the bundled map (an asset that was never shipped).
 *
 * @param code - a badge's own `code` (`BadgeCardViewModel.code`), e.g. `"value:12:t3"`.
 * @param coreValues - the core-value catalog already in redux (`RecognitionSelectors.getCoreValues()`).
 * @returns the bundled asset URL, or `null`.
 */
export const resolveCoreValueBadgeArt = (code: string, coreValues: CoreValue[]): string | null => {
  const match = code.match(VALUE_CODE_PATTERN);
  if (!match) {
    return null;
  }

  const tier = Number(match[2]);
  const coreValueId = Number(match[1]);
  const coreValue = coreValues.find((candidate) => candidate.id === coreValueId);
  if (!coreValue || typeof coreValue.icon_url !== "string" || coreValue.icon_url.length === 0) {
    return null;
  }

  const iconSlug = basenameWithoutExtension(coreValue.icon_url);
  if (iconSlug === null) {
    return null;
  }

  // `hasOwnProperty`, like the sibling resolvers, for both lookups: a bare index would hand back an
  // inherited `Object.prototype` member for a slug such as "constructor".
  const slug = Object.prototype.hasOwnProperty.call(SLUG_ALIASES, iconSlug) ? SLUG_ALIASES[iconSlug] : iconSlug;
  const key = `${slug}-t${tier}`;
  return Object.prototype.hasOwnProperty.call(CORE_VALUE_BADGE_ART, key) ? CORE_VALUE_BADGE_ART[key] : null;
};
